<template>
  <v-card class="fill-height" width="100vw">
    <v-card-title>Магазины</v-card-title>
    <v-card-text>
      <DataTable
        :headers="headers"
        :items="shops.items"
        :options="options_raw"
        :total="shops.total"
        searchable
        @updateOptions="updateOptions"
        @onSearch="searchQuery"
        @onAdd="$emit('onAdd')"
        @onClickRow="onClickRow"
      >
      </DataTable>
  </v-card-text>
</v-card>
</template>

<script>
import DataTable from '../ui/DataTable.vue';

export default{
  name: 'shops',

  props:{
    shops: Object
  },

  data: () => ({
    loading: false,
    options: {},
    search: ''
  }),

  computed: {

    headers(){
      return [
        {text: '#', align: 'start', value: 'id'}, {text: 'Название', align: 'start', value: 'name'},
        {text: 'Адрес', align: 'start', value: 'address'},
        {text: 'Активен', align: 'start', value: 'enabled'},
      ]
    },

    options_raw:{
      set(v){
        this.options = {...this.options,...v}
      },
      get(){
        return this.options
      }
    }
  },

  methods: {
    updateOptions(options){
      this.$emit('onGetList', {
        skip: options.page,
        limit: options.itemsPerPage,
        order_by: options.sortBy[0] ? options.sortBy[0] : null,
        direction: options.sortDesc[0] ? options.sortDesc[0] : null,
        include_deleted: options.include_deleted
      })
    },

    searchQuery(query){
      this.$emit('onSearch', {query: query, options: this.options});
    },

    onClickRow(item){
      this.$emit('onClickRow', item);
    },

    onAdd(){
      this.$emit('onAdd');
    }
  },

  mounted(){
    this.options = {
      sortBy: this.shops.order_by ? this.shops.order_by : [],
      sortDesc: this.shops.direction ? this.shops.direction : [],
      itemsPerPage: this.shops.limit ? this.shops.limit : 10,
      page: this.shops.skip ? this.shops.skip : 1,
      include_deleted: this.shops.include_deleted ? this.shops.include_deleted : false
    }
  },

  components:{
    DataTable
  }
}
</script>